import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Messages from './pages/Messages';
import Projects from './pages/Projects';
import ChatWidget from './pages/ChatWidget';
import { connectSocket, disconnectSocket } from './socketActions';

const App = ({ componentName = 'default', customMessage, page, ...props }) => {
    const dispatch = useDispatch();
    const jwtToken = useSelector((state) => state.auth.jwtToken);
    const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
    const [message] = useState('Hello from Octopus React!');
    const [count, setCount] = useState(0);

    
    const handleClick = () => {
        setCount(prevCount => prevCount + 1);
    };
    
    // Initialize socket connection when user is logged in
    useEffect(() => {
        if (isLoggedIn && jwtToken) {
            console.log('Initializing socket connection...');
            dispatch(connectSocket());
        }
        
        // Cleanup: disconnect socket when component unmounts
        return () => {
            dispatch(disconnectSocket());
        };
    }, [isLoggedIn, jwtToken, dispatch]);
    
    // Render Messages component if page is "message"
    if (page === 'message') {
        return <Messages page={page} {...props} />;
    }

    // Render ChatWidget (floating footer widget) if page is "chat-widget"
    if (page === 'chat-widget') {
        return <ChatWidget {...props} />;
    }
    
    // Render Projects component if page is "projects"
    if (page === 'projects') {
        return <Projects page={page} {...props} />;
    }
    
    // Default App component
    return (
        <div className="octopus-react-app">
            <h2>{customMessage || message}</h2>
            <p>Component: {componentName}</p>
            <div className="octopus-react-counter">
                <p>Click count: {count}</p>
                <button onClick={handleClick} className="octopus-react-button">
                    Click Me!
                </button>
            </div>
            <div className="octopus-react-info">
                <p>This is a React component rendered via WordPress shortcode!</p>
            </div>
        </div>
    );
};

export default App;

